'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import VerifyWithPasskeyModal from '@flipster/features/src/passkey/VerifyWithPasskeyModal';
import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { useOverlayItem } from '@flipster/overlay';

import { passkeyLoginFlowBunja } from './bunja';

const PasskeyLoginFlow = () => {
  const { onClose } = useOverlayItem();
  const { loginStepAtom, loginWithPasskey } = useBunja(passkeyLoginFlowBunja);
  const loginStep = useAtomValue(loginStepAtom);

  return (
    <VerifyWithPasskeyModal
      verifyStep={loginStep}
      onClickUnvailableButton={() => {
        window.open(zendesk.getUrl('RequestNew'), '_blank', 'noopener');
      }}
      onClickTryAgainButton={loginWithPasskey}
      onClose={onClose}
    />
  );
};

export default PasskeyLoginFlow;
